'use client';

import { Link } from '@/i18n/navigation';
import { useTranslations } from 'next-intl';
import { BrandMark } from '@/components/ui/BrandMark';

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: ErrorProps) {
  const t = useTranslations('errorPage');

  // Sanitizar mensaje (máximo 200 caracteres, fallback genérico)
  const errorMessage = error.message
    ? error.message.slice(0, 200) + (error.message.length > 200 ? '...' : '')
    : t('default');

  return (
    <main data-theme="dark" className="min-h-screen bg-bg text-ink grid place-items-center p-4">
      <div className="max-w-md w-full bg-panel border border-line rounded-2xl shadow-lg p-8 text-center">
        <BrandMark size={72} className="mx-auto mb-6" />
        <h1 className="font-display text-xl mb-3">{t('title')}</h1>
        <p className="text-muted text-sm mb-8 break-words">{errorMessage}</p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={reset}
            className="px-5 py-2.5 rounded-lg font-bold bg-accent text-onbright hover:opacity-90 transition cursor-pointer"
          >
            {t('tryAgain')}
          </button>
          <Link
            href="/"
            className="px-5 py-2.5 rounded-lg font-bold bg-panel-2 border border-line text-ink hover:border-accent/60 transition"
          >
            {t('goHome')}
          </Link>
        </div>
      </div>
    </main>
  );
}
